import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from '../../styles/app';

class EditBlockForm extends Component {

    state = {

    };
    render() {
        const { classes } = this.props;
        return (
            <form encType="multipart/form-data" className={classes.form} onSubmit={(e) => { e.preventDefault(); this.props.onSubmitForm(e, this.state) }}>
                <input type="hidden" name="_id" value={this.props._id} />
                <FormControl required fullWidth>
                    <InputLabel htmlFor="name">Blok Adı</InputLabel>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                        defaultValue={this.props.name}
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="floorStart">Kat Başlangıç</InputLabel>
                    <Input
                        id="floorStart"
                        name="floorStart"
                        type="text"
                        defaultValue={this.props.floorStart}
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="floorEnd">Kat Bitiş</InputLabel>
                    <Input
                        id="floorEnd"
                        name="floorEnd"
                        type="text"
                        defaultValue={this.props.floorEnd}
                    />
                </FormControl>
                <FormControl required fullWidth>
                    <InputLabel htmlFor="apartmentCount">Mevcut Daire Sayısı</InputLabel>
                    <Input
                        id="apartmentCount"
                        name="apartmentCount"
                        type="text"
                        defaultValue={this.props.apartments.length}
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    BLOĞU GÜNCELLE
                </Button>
            </form >
        )
    }
}

EditBlockForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(EditBlockForm);